import Vue from "vue";
import Router from "vue-router";
import MainLayout from "@/layouts/MainLayout";
import AuthLayout from "@/layouts/AuthLayout";
import LoginView from "@/views/Auth/LoginView";
import DashboardView from "@/views/Main/DashboardView";
import MailsView from "@/views/Main/Mail/MailsView";
import $store from "@/store"
import UsersReportView from "@/views/Main/Report/DeliveryStatistics/UsersReportView.vue";
import MonitoringMailsView from "@/views/Main/Mail/MonitoringMailsView";
import PrintPackagesView from "@/views/Main/PrintPackage/PrintPackagesView";
import PostPackagesView from "@/views/Main/PostPackage/PostPackagesView";
import PostPackageGroupsView from "@/views/Main/PostPackageGroup/PostPackageGroupsView";
import PrintPackageView from "@/views/Main/PrintPackage/PrintPackageView";
import PostPackageView from "@/views/Main/PostPackage/PostPackageView";
import PostPackageGroupView from "@/views/Main/PostPackageGroup/PostPackageGroupView";
import MailView from "@/views/Main/Mail/MailView";
import PostPackageCreateView from "@/views/Main/PostPackage/PostPackageCreateView";
import PostPackageSetMailsView from "@/views/Main/PostPackage/PostPackageSetMailsView";
import MailBulkUnsetPostPackageView from "@/views/Main/Mail/MailBulkUnsetPostPackageView";
import MailsPerformView from "@/views/Main/Mail/MailsPerformView";
import UsersManagementView from "@/views/Main/UserManagement/UsersManagementView";
import WebClientLayout from "@/layouts/WebClientLayout";
import WebClientDashboardView from "@/views/WebClient/DashboardView"
import HomeLayout from "@/layouts/HomeLayout";
import ImportRegistryView from "@/views/WebClient/ImportRegistryView";
import RegistriesView from "@/views/WebClient/RegistriesView";
import RegistryView from "@/views/WebClient/RegistryView";
import TempMailView from "@/views/WebClient/TempMailView";
import ReportView from "@/views/WebClient/ReportView";
import PostIndexSettingsView from "@/views/Main/Settings/PostIndexSettingsView";
import BranchRegionReportView from "@/views/Main/Report/BranchStatistics/BranchRegionReportView.vue";
import BranchPostIndexReportView from "@/views/Main/Report/BranchStatistics/BranchPostIndexReportView.vue";
import ClientReportView from "@/views/Main/Report/ClientStatistics/ClientReportView.vue";
import BranchAreaReportView from "@/views/Main/Report/BranchStatistics/BranchAreaReportView.vue";
import DistributionMailsView from "@/views/Main/Mail/DistributionMailsView";
import SetAncientMailsView from "@/views/Main/Mail/SetAncientMailsView";
import SearchPostIndexView from "@/views/Main/Search/SearchPostIndexView";
import ClientIncomingRegionReportView from "@/views/Main/Report/ClientStatistics/ClientIncomingRegionReportView.vue";
import DeliveredReportView from "@/views/Main/Report/DeliveryStatistics/DeliveredReportView.vue";
import PerformsReportView from "@/views/Main/Report/DeliveryStatistics/PerformsReportView.vue";
import TaskPerformanceRegionReportView from "@/views/Main/Report/DeliveryStatistics/TaskPerformanceRegionReportView.vue";
import TaskPerformanceAreaReportView from "@/views/Main/Report/DeliveryStatistics/TaskPerformanceAreaReportView.vue";
import PagesCountRegionView from "@/views/Main/Report/CostAnalysisStatistics/PagesCountRegionView.vue";
import PagesCountAreaReportVIew from "@/views/Main/Report/CostAnalysisStatistics/PagesCountAreaReportVIew.vue";
import MailForwardView from "@/views/Main/Mail/MailForwardView.vue";
import PerformsAreaReportView from "@/views/Main/Report/DeliveryStatistics/PerformsAreaReportView.vue";
import PagesSumRegionView from "@/views/Main/Report/CostAnalysisStatistics/PagesSumRegionView.vue";
import PagesCountEconomistView from "@/views/Main/Report/CostAnalysisStatistics/PagesCountEconomistView.vue";

Vue.use(Router);

let router = new Router({
    mode: "hash",
    routes: [
        {
            path: "/",
            redirect: {
                name: "home"
            }
        },
        {
            path: "/auth",
            component: AuthLayout,
            meta: {
                requiresAuth: false,
                disableWebClient: false,
                disableMailUsers: false
            },
            redirect: {name: "login"},
            children: [
                {
                    path: "login",
                    name: "login",
                    component: LoginView
                }
            ]
        },
        {
            path: "/home",
            name: "home",
            component: HomeLayout,
            meta: {
                requiresAuth: true,
            },
            children: [
                {
                    path: "/main",
                    component: MainLayout,
                    meta: {
                        disableWebClient: true,
                        disableMailUsers: false
                    },
                    children: [
                        {
                            path: "dashboard",
                            name: "dashboard",
                            component: DashboardView
                        },
                        {
                            path: "print-package/:uid",
                            name: "print-package",
                            component: PrintPackageView
                        },
                        {
                            path: "print-packages",
                            name: "print-packages",
                            component: PrintPackagesView
                        },
                        {
                            path: "post-package/create",
                            name: "post-package-create",
                            component: PostPackageCreateView
                        },
                        {
                            path: "post-package/set-mails/:uid",
                            name: "post-package-set-mails",
                            component: PostPackageSetMailsView
                        },
                        {
                            path: "ancient-mail/set-mails",
                            name: "ancient-mail-set-mails",
                            component: SetAncientMailsView
                        },
                        {
                            path: "post-package/:uid",
                            name: "post-package",
                            component: PostPackageView
                        },
                        {
                            path: "post-packages",
                            name: "post-packages",
                            component: PostPackagesView
                        },
                        {
                            path: "post-package-group/:uid",
                            name: "post-package-group",
                            component: PostPackageGroupView
                        },
                        {
                            path: "post-package-groups",
                            name: "post-package-groups",
                            component: PostPackageGroupsView
                        },
                        {
                            path: "mails/listing",
                            name: "mails-listing",
                            component: MailsView
                        },
                        {
                            path: "mails/monitoring",
                            name: "mails-monitoring",
                            component: MonitoringMailsView
                        },
                        {
                            path: "mails/forward",
                            name: "mails-forward",
                            component: MailForwardView
                        },
                        {
                            path: "mails/distribution",
                            name: "mails-distribution",
                            component: DistributionMailsView
                        },
                        {
                            path: "mails/bulk-unset-post-package",
                            name: "mails-bulk-unset-post-package",
                            component: MailBulkUnsetPostPackageView
                        },
                        {
                            path: "mails/perform",
                            name: "mails-perform",
                            component: MailsPerformView
                        },
                        {
                            path: "mails/:uid",
                            name: "mail",
                            component: MailView
                        },
                        {
                            path: "report/processing/region",
                            name: "report-processing-region",
                            component: BranchRegionReportView
                        },
                        {
                            path: "report/processing/pages-count-region",
                            name: "report-processing-pages-count-region",
                            component: PagesCountRegionView
                        },
                        {
                            path: "report/processing/pages-sum-region",
                            name: "report-processing-pages-sum-region",
                            component: PagesSumRegionView
                        },
                        {
                            path: "report/processing/pages-economist",
                            name: "report-processing-pages-economist",
                            component: PagesCountEconomistView
                        },
                        {
                            path: "report/processing/pages-count-area/:regionId",
                            name: "report-processing-pages-count-area",
                            component: PagesCountAreaReportVIew
                        },
                        {
                            path: "report/processing/area/:regionId",
                            name: "report-processing-area",
                            component: BranchAreaReportView
                        },
                        {
                            path: "report/processing/postindex/:regionId/:areaId",
                            name: "report-processing-postindex",
                            component: BranchPostIndexReportView
                        },
                        {
                            path: "report/processing/regional-task-performance",
                            name: "report-processing-regional-task-performance",
                            component: TaskPerformanceRegionReportView
                        },
                        {
                            path: "report/processing/areal-task-performance/:regionId",
                            name: "report-processing-areal-task-performance",
                            component: TaskPerformanceAreaReportView
                        },
                        {
                            path: "report/processing/client",
                            name: "report-processing-client",
                            component: ClientReportView
                        },
                        {
                            path: "report/users",
                            name: "report-users",
                            component: UsersReportView
                        },
                        {
                            path: "report/processing/clientincomming",
                            name: "report-clientincomming",
                            component: ClientIncomingRegionReportView
                        },
                        {
                            path: "report/perform",
                            name: "report-perform",
                            component: PerformsReportView
                        },
                        {
                            path: "report/area-perform/:regionId",
                            name: "report-area-perform",
                            component: PerformsAreaReportView
                        },
                        {
                            path: "report/delivered",
                            name: "report-delivered",
                            component: DeliveredReportView
                        },
                        {
                            path: "users/management",
                            name: "users-management",
                            component: UsersManagementView
                        },
                        {
                            path: "settings/post-index",
                            name: "settings-post-index",
                            component: PostIndexSettingsView
                        },
                        {
                            path: "search/post-index",
                            name: "post-index-search",
                            component: SearchPostIndexView
                        },
                    ]
                },
                {
                    path: "/web-client",
                    component: WebClientLayout,
                    name: "web-client",
                    meta: {
                        disableWebClient: false,
                        disableMailUsers: true
                    },
                    children: [
                        {
                            path: "",
                            name: "web-client-dashboard",
                            component: WebClientDashboardView
                        },
                        {
                            path: "import",
                            name: "web-client-import",
                            component: ImportRegistryView
                        },
                        {
                            path: "report",
                            name: "web-client-report",
                            component: ReportView
                        },
                        {
                            path: "registries",
                            name: "web-client-registries",
                            component: RegistriesView
                        },
                        {
                            path: "registry/:id",
                            name: "web-client-registry",
                            component: RegistryView
                        },
                        {
                            path: "temp-mail/:uid",
                            name: "web-client-temp-mail",
                            component: TempMailView
                        }
                    ]
                }
            ]
        },
    ]
})

router.beforeEach((to, from, next) => {
    let isNextCalled = false

    if (to.matched.length === 0) {
        next({name: "dashboard"})
        isNextCalled = true
    }

    // requiresAuth
    if (to.matched.some(record => {
        return typeof (record.meta.requiresAuth) === "boolean" && record.meta.requiresAuth
    })) {
        if (!$store.getters.isTokenOk) {
            next({name: "login"})
            isNextCalled = true
        }
    }

    // disableWebClient
    if (!isNextCalled && to.matched.some(record => {
        return typeof (record.meta.disableWebClient) === "boolean" && record.meta.disableWebClient
    })) {
        console.log("disableWebClient")
    }

    // disableMailUsers
    if (!isNextCalled && to.matched.some(record => {
        return typeof (record.meta.disableMailUsers) === "boolean" && record.meta.disableMailUsers
    })) {
        console.log("disableMailUsers")
    }

    if (!isNextCalled)
        next()
})

export default router
